<div>
  <div bsModal #childModal="bs-modal" class="modal" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-md">
      <div class="modal-content" [style.width]="maxWidth ? '100%' : '70%'" [style.padding]="!maxWidth ? '20px' : '0'">
        <div class="modal-body">
          <h5 *ngIf="message">{{ message }}</h5>
          <div *ngIf="messageHtml" [innerHTML]="messageHtml" class="messageHTML"></div>
          <button
            *ngIf="buttonOne"
            type="button"
            class="btn btn-primary aru"
            (click)="buttonOneClick()"
            [ngClass]="{ 'smaller-buttons': buttonOne && buttonTwo }"
            [style.background-color]="buttonOneColor"
            [style.border-color]="buttonOneColor">
            {{ buttonOne }}
          </button>
          <button
            *ngIf="buttonTwo"
            type="button"
            class="btn btn-primary aru"
            (click)="buttonTwoClick()"
            [ngClass]="{ 'smaller-buttons': buttonOne && buttonTwo }"
            [style.background-color]="buttonOneColor"
            [style.border-color]="buttonTwoColor">
            {{ buttonTwo }}
          </button>
          <button
            type="button"
            class="btn btn-default aru"
            (click)="cancel()"
            [ngClass]="{ 'smaller-buttons': buttonOne && buttonTwo }"
            [style.color]="cancelColor">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
